import { render, staticRenderFns } from "./InternalLinkItem.vue?vue&type=template&id=39fb2f30&scoped=true&"
import script from "./InternalLinkItem.vue?vue&type=script&lang=js&"
export * from "./InternalLinkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fb2f30",
  null
  
)

export default component.exports